import React from "react";

const Unchecked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    role="img"
  >
    <path
      id="Ellipse_1304_-_Outline"
      data-name="Ellipse 1304 - Outline"
      d="M10,1a9,9,0,1,0,9,9,9.01,9.01,0,0,0-9-9m0-1A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z"
      fill="#b1b1b1"
    />
  </svg>
);

export default Unchecked;
